<script>
  import simulacaoPagamentoService from './servico';
  import radio from '~componentes/Radio.vue';
  import { checkbox } from 'vue-strap';
  
  export default {
    components: { radio, checkbox },
    data() {
      return {
        mostrarFormulario: true,
        simulacao: this.camposModelo(),
        impostosTaxas: undefined,
        carregando: false,
      }
    },
    mounted() {
      this.$root.tituloDaPagina = 'Simulação de Pagamentos';
    },
    methods: {
      calcular() {
        $('#calcular').button('loading');

        const calculo = simulacaoPagamentoService.calcularValorFinal(this.simulacao, this.impostosTaxas);
        this.$set(this.simulacao, 'valorFinal', calculo.valor_calculado.toFixed(2));
        this.$set(this.simulacao, 'baseCalculoISS', calculo.iss.valor.toFixed(2));

        $('#calcular').button('reset');
        return true;
      },

      labelValorFinal() {
        return this.simulacao.tipoCalculo === 'bruto' ? 'Valor líquido' : 'Valor bruto';
      },
      desabilitaValorBase() {
        if (this.simulacao.isINSS && this.simulacao.tipoCalculo === 'bruto') {
          this.$set(this.simulacao, 'valorBase', 0.00);
          return true;
        } else {
          return false;
        }
      },
      atualizaValorBase(value) {
        this.$set(this.simulacao, 'valorBase', value);
      },

      camposModelo() {
        return {
          tipoPessoa: 'fisica',
          tipoCalculo: 'liquido',
          valorBase: 0.00,
          valorFinal: 0.00,
          taxaISS: 0.00,
          valorINSSPatronal: 0.00,
          baseCalculoISS: 0.00,
          isIRRF: false,
          isINSS: false,
          isINSSRetencao: false,
          isISS: false,
          isPIS: false,
          isCOFINS: false,
          isCSLL: false,
        };
      },
      async resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
        const impostosTaxas = await simulacaoPagamentoService.obterImpostosTaxas();
        this.$set(this, 'impostosTaxas', impostosTaxas);
        this.$set(this.simulacao, 'taxaISS', impostosTaxas.AliquotaISS);
      },
      validar() {
      }
    },
    async created() {
      const impostosTaxas = await simulacaoPagamentoService.obterImpostosTaxas();
      this.$set(this, 'impostosTaxas', impostosTaxas);
      this.$set(this.simulacao, 'taxaISS', impostosTaxas.AliquotaISS);
    },
    watch: {
      'simulacao.valorINSSPatronal': function (value) {
        this.atualizaValorBase(value);
      }
    }
  }
</script>

<template>
    <div>
      <form @submit.prevent="validar">
        <div class="row no-margins text-left text-white">
          <b>Retenção de impostos</b>
        </div>
        <div class="row no-margins" style="border: 0.4px solid white; border-radius: 3px; margin-bottom: 30px !important;">
          <div class="col-xs-2">
            <div class="checkbox">
              <checkbox class="text-white" v-model="simulacao.isIRRF" value="true" type="success">
                IRRF
              </checkbox>
            </div>
          </div>

          <div class="col-xs-2">
            <div class="checkbox">
              <checkbox class="text-white" v-model="simulacao.isINSS" value="true" type="success">
                INSS Patronal
              </checkbox>
            </div>
          </div>

          <div class="col-xs-2">
            <div class="checkbox">
              <checkbox class="text-white" v-model="simulacao.isINSSRetencao" value="true" type="success">
                INSS Retenção
              </checkbox>
            </div>
          </div>

          <div class="col-xs-1">
            <div class="checkbox">
              <checkbox class="text-white" v-model="simulacao.isISS" value="true" type="success">
                ISS
              </checkbox>
            </div>
          </div>

          <!--
          <div class="col-xs-1">
            <div class="checkbox">
              <checkbox class="text-white" v-model="simulacao.isPIS" value="true" type="success">
                PIS
              </checkbox>
            </div>
          </div>

          <div class="col-xs-2">
            <div class="checkbox">
              <checkbox class="text-white" v-model="simulacao.isCOFINS" value="true" type="success">
                COFINS
              </checkbox>
            </div>
          </div>

          <div class="col-xs-2">
            <div class="checkbox">
              <checkbox class="text-white" v-model="simulacao.isCSLL" value="true" type="success">
                CSLL
              </checkbox>
            </div>
          </div> 
          -->
        </div>

        <div class="row no-margins margin-bottom-5 text-left text-white">
          <b>Para simulação do valor líquido é possível informar o valor bruto no campo abaixo somado ao valor do INSS patronal.</b>
        </div>
        <div class="row">
          <div class="col-xs-3">
            <div class="form-group" :class="{'has-error': errors.has('valorINSSPatronal')}">
              <input type="text"
                     class="form-control text-right"
                     id="valor-base"
                     v-model="simulacao.valorINSSPatronal"
                     data-vv-name="valorINSSPatronal"
                     v-validate=""
                     data-vv-as="valor inss patronal"
                     :disabled="!desabilitaValorBase()">

              <p class="text-danger" v-show="errors.has('valorINSSPatronal')">{{ errors.first('valorINSSPatronal') }}</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-3">
            <div class="form-group" :class="{'has-error': errors.has('valorBase')}">
              <div class="form-group radios control-label margin-bottom-3 ">
                <radio v-model="simulacao.tipoCalculo"
                       selected-value="liquido"
                       type="success"
                       :inline="true"
                       class="no-margin-top no-margin-bottom margin-right-10 text-white">
                  <b>Líquido</b>
                </radio>
                <radio v-model="simulacao.tipoCalculo"
                       selected-value="bruto"
                       type="success"
                       :inline="true"
                       class="no-margin-top no-margin-bottom text-white">
                  <b>Bruto</b>
                </radio>
              </div>

              <input type="text"
                     class="form-control text-right"
                     id="valor-base"
                     v-model="simulacao.valorBase"
                     data-vv-name="valorBase"
                     v-validate=""
                     data-vv-as="valor base"
                     :disabled="desabilitaValorBase()">

              <p class="text-danger" v-show="errors.has('valorBase')">{{ errors.first('valorBase') }}</p>
            </div>
          </div>

          <div class="col-xs-3">
            <div class="form-group" :class="{'has-error': errors.has('taxaISS')}">
              <label class="control-label text-white" for="taxa-iss">Taxa ISS (%)</label>

              <input type="text"
                     class="form-control text-right"
                     id="valor-base"
                     v-model="simulacao.taxaISS"
                     data-vv-name="taxaISS"
                     v-validate=""
                     data-vv-as="taxa iss"
                     :disabled="!simulacao.isISS">

              <p class="text-danger" v-show="errors.has('taxaISS')">{{ errors.first('taxaISS') }}</p>
            </div>
          </div>

          <div class="col-xs-3">
            <div class="form-group" :class="{'has-error': errors.has('baseCalculoISS')}">
              <label class="control-label text-white" for="base-calculo-iss">Base de cálculo do ISS</label>

              <input type="text"
                     class="form-control text-right"
                     id="valor-base"
                     v-model="simulacao.baseCalculoISS"
                     data-vv-name="baseCalculoISS"
                     v-validate=""
                     data-vv-as="base calculo iss" 
                     :disabled="!simulacao.isISS">

              <p class="text-danger" v-show="errors.has('baseCalculoISS')">{{ errors.first('baseCalculoISS') }}</p>
            </div>
          </div>

          <div class="col-xs-3">
            <div class="form-group" :class="{'has-error': errors.has('valorFinal')}">
              <label class="control-label text-white" for="valor-final">{{ labelValorFinal() }}</label>

              <input type="text"
                     class="form-control text-right"
                     id="valor-base"
                     v-model="simulacao.valorFinal"
                     data-vv-name="valorFinal"
                     v-validate="''"
                     data-vv-as="valor final"
                     disabled>

              <p class="text-danger" v-show="errors.has('valorFinal')">{{ errors.first('valorFinal') }}</p>
            </div>
          </div>
        </div>

        <div class="row" style="margin-top: 40px !important; display: table">
          <div class="col-xs-12">
            <div class="form-group">
              <button type="button"
                      class="btn btn-default margin-right-10"
                      @click="resetarComponente()">
                Limpar
              </button>

              <button id="calcular"
                      type="button"
                      class="btn btn-primary"
                      @click="calcular">
                <i class="fa fa-calculator"></i>
                Calcular
              </button>
            </div>
          </div>
        </div>

      </form>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/simulacao-pagamento/SimulacaoPagamento.vue